import { computed } from "@ember/object";
import { classNames } from "@ember-decorators/component";
import { uniqueItemsFromArray } from "discourse/lib/array-tools";
import { makeArray } from "discourse/lib/helpers";
import MultiSelectComponent from "discourse/select-kit/components/multi-select";
import {
  MAIN_COLLECTION,
  pluginApiIdentifiers,
  selectKitOptions,
} from "discourse/select-kit/components/select-kit";
import CreateColorRow from "./create-color-row.gjs";
import SelectedChoice from "./selected-choice.gjs";
import SelectedChoiceColor from "./selected-choice-color.js";

@classNames("list-setting")
@selectKitOptions({
  filterable: true,
})
@pluginApiIdentifiers("list-setting")
export default class ListSetting extends MultiSelectComponent {
  /** @type {(string | { id?: string | number, name?: string, value?: string | number, label?: string, color?: string })[] | null | undefined} */
  choices = null;

  /** @type {string | null | undefined} */
  nameProperty = null;

  /** @type {string | null | undefined} */
  valueProperty = null;

  /** @returns {ListSetting["choices"]} */
  @computed("choices")
  get content() {
    return this.choices;
  }

  @computed("settingName")
  get selectedChoiceComponent() {
    if (this.settingName?.includes("color")) {
      return SelectedChoiceColor;
    } else {
      return SelectedChoice;
    }
  }

  modifyComponentForRow(collection) {
    if (collection === MAIN_COLLECTION && this.settingName?.includes("color")) {
      return CreateColorRow;
    }
  }

  deselect(value) {
    this.onChangeChoices &&
      this.onChangeChoices(
        uniqueItemsFromArray([value, ...makeArray(this.choices)])
      );

    super.deselect(...arguments);
  }
}
